import React, { useState } from "react";
import BaseModal from "components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";

export default function APIManagerFormModal({ show, onClose, mode, userData, onSuccess }) {
  const [errors, setErrors] = useState({});
  const {userid} = useSession();



  const validateForm = () => {
    const requiredFields = [
      "pname",
      "sname",
      "url",
      "api_key",
      "username",
      "password",
      "code",
      "type",
      "status",
    ];
    let newErrors = {};

    requiredFields.forEach((field) => {
      const value = document.querySelector(`[name="${field}"]`)?.value?.trim();
      if (!value) {
        newErrors[field] = `${field.replace("_", " ")} is required.`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      showMainToast("Please correct the errors before saving.", "danger");
      return;
    }

    const formData = new FormData(document.getElementById("api-manager-form"));
    formData.append("action", "ADDUpdate");
    formData.append("userid", userid);
    formData.append("id", userData?.id || "");

    try {
      const response = await fetch("https://pro.mokshiq.in/api_manager_action", {
        method: "POST",
         headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: formData,
      });

      if (!response.ok) {
        showMainToast("Something went wrong!", "danger");
      }

      const result = await response.json();
      if (result.status) {
        showMainToast(result.data || "Success!", "success");
        onClose();
         if (onSuccess) onSuccess();
      } else {
        showMainToast(result.data || "Something went wrong!", "danger");
      }
    } catch (error) {
      showMainToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={mode === "edit" ? "Edit API Manager" : "Add API Manager"}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: mode === "edit" ? "Update" : "Save", className: "btn-primary", onClick: handleSave },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="api-manager-form">
          {/* pname */}
          <div className="col-md-6">
            <label className="form-label">PName</label>
            <input
              className={`form-control ${errors.pname ? "is-invalid" : ""}`}
              name="pname"
              type="text"
              defaultValue={userData?.["Product Name"]|| ""}
            />
            {errors.pname && <div className="text-danger mt-1">{errors.pname}</div>}
          </div>

          {/* sname */}
          <div className="col-md-6">
            <label className="form-label">SName</label>
            <input
              className={`form-control ${errors.sname ? "is-invalid" : ""}`}
              name="sname"
              type="text"
              defaultValue={userData?.["Sort Name"] || ""}
            />
            {errors.sname && <div className="text-danger mt-1">{errors.sname}</div>}
          </div>

          {/* url */}
          <div className="col-md-6">
            <label className="form-label">URL</label>
            <input
              className={`form-control ${errors.url ? "is-invalid" : ""}`}
              name="url"
              type="url"
              defaultValue={userData?.URL || ""}
            />
            {errors.url && <div className="text-danger mt-1">{errors.url}</div>}
          </div>

          {/* api_key */}
          <div className="col-md-6">
            <label className="form-label">API Key</label>
            <input
              className={`form-control ${errors.api_key ? "is-invalid" : ""}`}
              name="api_key"
              type="text"
              defaultValue={userData?.["API KEY"] || ""}
            />
            {errors.api_key && <div className="text-danger mt-1">{errors.api_key}</div>}
          </div>

          {/* username */}
          <div className="col-md-6">
            <label className="form-label">Username</label>
            <input
              className={`form-control ${errors.username ? "is-invalid" : ""}`}
              name="username"
              type="text"
              defaultValue={userData?.["User Name"] || ""}
            />
            {errors.username && <div className="text-danger mt-1">{errors.username}</div>}
          </div>

          {/* password */}
          <div className="col-md-6">
            <label className="form-label">Password</label>
            <input
              className={`form-control ${errors.password ? "is-invalid" : ""}`}
              name="password"
              type="password"
              defaultValue={userData?.Password || ""}
            />
            {errors.password && <div className="text-danger mt-1">{errors.password}</div>}
          </div>

          {/* optional */}
          <div className="col-md-6">
            <label className="form-label">Optional</label>
            <input
              className="form-control"
              name="optional"
              type="text"
              defaultValue={userData?.optional || ""}
            />
          </div>

          {/* code */}
          <div className="col-md-6">
            <label className="form-label">Code</label>
            <input
              className={`form-control ${errors.code ? "is-invalid" : ""}`}
              name="code"
              type="text"
              defaultValue={userData?.code || ""}
            />
            {errors.code && <div className="text-danger mt-1">{errors.code}</div>}
          </div>

          {/* type */}
          <div className="col-md-6">
            <label className="form-label">Type</label>
            <input
              className={`form-control ${errors.type ? "is-invalid" : ""}`}
              name="type"
              type="text"
              defaultValue={userData?.Type || ""}
            />
            {errors.type && <div className="text-danger mt-1">{errors.type}</div>}
          </div>

          {/* status */}
          <div className="col-md-6">
            <label className="form-label">Status</label>
            <select
              className={`form-select ${errors.status ? "is-invalid" : ""}`}
              name="status"
              defaultValue={userData?.Status || ""}
            >
              <option value="">-- Select --</option>
              <option value="True">Active</option>
              <option value="False">Inactive</option>
            </select>
            {errors.status && <div className="text-danger mt-1">{errors.status}</div>}
          </div>
        </form>
      </div>
    </BaseModal>
  );
}
